import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class WorkerService {
  private apiService = inject(ApiService);
  cookieWorkerId = Cookies.get('workerId');

  getWorker() {
    return this.apiService.getAll(`worker/${this.cookieWorkerId}`);
  }
}
